import { gql } from 'graphql-tag'
import { openingTimeFragment } from '../checklistQueries'

const hourlyChecklistFragment = gql`
  fragment HourlyChecklistFragment on HourlyChecklist {
    id
    date
    type
    status {
      hour
      status
    }
  }
`

export const fetchHourlyChecklist = gql`
  query fetchHourlyChecklist(
    $stationId: ID!
    $longPeriodDate: String!
    $shortPeriodDate: String!
    $longPeriodWeekday: WeekDay
    $shortPeriodWeekday: WeekDay
    $type: HourlyChecklistTypeEnum!
  ) {
    longPeriod: hourlyChecklist(stationId: $stationId, date: $longPeriodDate, type: $type) {
      ...HourlyChecklistFragment
    }
    shortPeriod: hourlyChecklist(stationId: $stationId, date: $shortPeriodDate, type: $type) {
      ...HourlyChecklistFragment
    }
    longPeriodOpeningHours: openingTimes(stationId: $stationId, date: $longPeriodDate, weekday: $longPeriodWeekday) {
      ...OpeningTimeFragment
    }
    shortPeriodOpeningHours: openingTimes(stationId: $stationId, date: $shortPeriodDate, weekday: $shortPeriodWeekday) {
      ...OpeningTimeFragment
    }
  }
  ${hourlyChecklistFragment}
  ${openingTimeFragment}
`

export const upsertHourlyChecklist = gql`
  mutation upsertHourlyChecklist(
    $date: String!
    $hour: Int!
    $status: Boolean!
    $stationId: ID!
    $type: HourlyChecklistTypeEnum!
  ) {
    upsertHourlyChecklist(stationId: $stationId, data: { hour: $hour, status: $status, date: $date, type: $type }) {
      id
      status {
        status
        hour
      }
    }
  }
`
